/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MedicalSystemSubCategory = {
    MvTherapy: 'MVTherapy',
    LightIonTherapy: 'LightIonTherapy',
    KVTherapy: 'kVTherapy',
    Brachytherapy: 'Brachytherapy',
    OtherTreatmentMachine: 'OtherTreatmentMachine',
    Ct: 'CT',
    Mrt: 'MRT',
    PetCt: 'PET_CT',
    PetMrt: 'PET_MRT',
    OtherImagingMachine: 'OtherImagingMachine',
    Pacs: 'PACS',
    Ois: 'OIS',
    OtherPdms: 'OtherPDMS',
    Tps: 'TPS',
    OtherMedicalSystem: 'OtherMedicalSystem',
    OtherSoftware: 'OtherSoftware'
} as const;
export type MedicalSystemSubCategory = typeof MedicalSystemSubCategory[keyof typeof MedicalSystemSubCategory];


export function MedicalSystemSubCategoryFromJSON(json: any): MedicalSystemSubCategory {
    return MedicalSystemSubCategoryFromJSONTyped(json, false);
}

export function MedicalSystemSubCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemSubCategory {
    return json as MedicalSystemSubCategory;
}

export function MedicalSystemSubCategoryToJSON(value?: MedicalSystemSubCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the MedicalSystemSubCategory interface.
 */
 export function instanceOfMedicalSystemSubCategory(value: any): value is MedicalSystemSubCategory {
    return Object.values(MedicalSystemSubCategory).includes(value)
}

